import React from 'react';

export default function Bg() {
  return (
    <div className='follot-digest-bg'></div>
  )
}